



















import Vue from 'vue'
import { Etablissement } from '@/models/Etablissement';
import etablissementCard from '@/features/etablissements/components/etablissement-card.vue';
export default Vue.extend({
  props : {
      etablissements : {
          default : () => [],
          type : Array
      },
  },
  components : { etablissementCard },
})
